<template>
    <div class="vx-col md:w-full sm:w-auto">
        <vx-tooltip :text="$t('button.edit')" position="top">
            <feather-icon icon="EditIcon" class="ml-0 mr-4 action-success icon-btn"
                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                          @click="editRecord"/>
        </vx-tooltip>

        <vx-tooltip :text="$t('button.delete')" position="top">
            <feather-icon icon="TrashIcon" class="ml-0 action-err icon-btn"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="confirmDeleteRecord"/>
        </vx-tooltip>
    </div>
</template>

<script>
export default {
    name: 'CellRendererActions',
    methods: {
        editRecord() {
            this.$router.push(`/user/edit-customer?id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá khách hàng "${this.params.data.fullName}" không ?`,
                accept: this.deleteRecord,
                acceptText: this.$t('button.delete'),
                cancelText: this.$t('button.cancel')
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`/customer/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá khách hàng thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
